module.exports = __webpack_public_path__ + "static/media/12_JuergenKrause_webfinal.ff55caac.jpg";